import { TRIGGER_METADATA, WORKFLOW_TRIGGERS } from 'modules/workflows/constants';
import { StartNodeData, Workflow } from 'modules/workflows/types';

const getResourceValue = (nodeData: StartNodeData) => {
  const { nodeClass } = nodeData;
  const fieldName = TRIGGER_METADATA[nodeClass]?.resourceFieldName;
  const fieldValue = nodeData[fieldName as string];

  return fieldValue == null ? undefined : `${fieldValue}`;
};

// used during the handleUpdate function to correctly set the workflow's trigger event names
// that are sent to the backend.
export const getTriggerEventNames = (trigger: string, customEventName?: string) => {
  if (TRIGGER_METADATA[trigger]?.triggerEventNames) {
    return [TRIGGER_METADATA[trigger]?.triggerEventNames];
  } else if (trigger === WORKFLOW_TRIGGERS.TRIGGERED_CUSTOM_EVENT) {
    return [customEventName || ''];
  } else {
    return [];
  }
};

const parseLimit = (limit?: string | number | null) => (limit ? Number(limit) : null);

export const parseWorkflowForSaving = (
  workflow: Partial<Workflow>,
  { nodeData }: Partial<StartNodeData>,
) => {
  const resourceValue = getResourceValue(nodeData);

  const triggerEventNames = getTriggerEventNames(nodeData.nodeClass, resourceValue) as string[];

  return {
    triggerEventNames,
    workflowLifetimeLimit: parseLimit(workflow?.workflowLifetimeLimit),
    workflowSimultaneousLimit: parseLimit(workflow?.workflowSimultaneousLimit),
    workflowConcurrentJourneyEntranceCriteria: workflow?.workflowConcurrentJourneyEntranceCriteria,
  };
};
